import { render } from "./MoatScoreRankBody.vue?vue&type=template&id=7749530a"
import script from "./MoatScoreRankBody.vue?vue&type=script&lang=js"
export * from "./MoatScoreRankBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__